class pageListController {

  constructor( $scope, $state, pageContentService, messageService, access ) {
    this.$scope = $scope;
    this.$state = $state;
    this.pageContentService = pageContentService;
    this.messageService = messageService;
    this.access = access;
  }

  $onInit() {

  }

  filter(){
    if (!this.loading && this.filtertext){
      this.isFiltered = true;
      this.loading = true;
      this.pages = this.pageContentService.search(this.filtertype, this.filtertext);
      this.loading = false;
    }
  }

  clearfilter(){
    if (this.isFiltered) {
      this.isFiltered = false;
      this.loading = true;
      this.pages = this.pageContentService.list();
      this.loading = false;
    }
  }

  filtertypeChange() {
    switch(this.filtertype) {
      default:
        this.filtertext = '';
        break;
    }
  }

  editLink(slug){
    this.$state.go('app.admin.'+(this.type ? this.type+'P' : 'p')+'ageContent-edit', { page: slug });
  }
}

pageListController.$inject = [ '$scope', '$state', 'pageContentService', 'messageService', 'access' ];

export default pageListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/pageContent/controllers/pageContent.list.controller.js